import { twMerge } from 'tailwind-merge';

/**
 * The Obangsaek signature: 4px, five equal segments, in canonical order.
 * DESIGN.md specifies this exact treatment as the cultural signature below the
 * hero — it is the one decorative element the system allows, so it stays
 * literal and is defined once rather than re-typed per page.
 */
export const OBANGSAEK = ['#C8102E', '#0047AB', '#FFB81C', '#F5F5F0', '#1C1C1C'] as const;

export default function ObangsaekStripe({ className }: { className?: string }) {
  return (
    <div className={twMerge('flex h-1 w-full', className)} aria-hidden="true">
      {OBANGSAEK.map((color) => (
        <div key={color} className="flex-1" style={{ backgroundColor: color }} />
      ))}
    </div>
  );
}
